import { SvgIcon } from '@mui/material';
import React from 'react';

const SCOAdministrativeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 150 150"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <path d="m99.19,120.96c-1.25,1.36-2.9,2.19-4.66,2.35l-10.22.91c-1.01.09-1.86-.83-1.78-1.94l.84-11.15c.14-1.92.91-3.72,2.15-5.08l36.7-40.16,15.07,13.5-38.1,41.57Z" />
          <path d="m149.28,66.32l-7.96,8.68-15.07-13.5,7.96-8.68c.97-1.05,2.53-1.05,3.5,0l11.58,9.69c.97,1.05.97,2.76,0,3.81Z" />
        </g>
        <g>
          <path d="m33.6,3.75v31.61H2.53C13.11,24.6,23.51,14.01,33.6,3.75Z" />
          <path d="m81.77,100.44l28.11-30.67V7.06c0-3.9-3.02-7.06-6.75-7.06h-61.06v38.81c0,2.99-2.32,5.43-5.19,5.43H0v98.74C0,146.86,3.02,150,6.72,150h94.23c4.93,0,8.93-4.24,8.93-9.47v-21.51l-5.55,6.05c-2.05,2.25-4.78,3.62-7.69,3.88l-16.88,1.52c-1.67.15-3.08-1.38-2.94-3.21l1.38-18.43c.24-3.17,1.5-6.14,3.57-8.39ZM50.83,29.35c.8-1.9,2.3-2.71,4.27-2.7,5.56.01,11.12,0,16.67,0s11.03-.02,16.55.01c3.28.02,5.39,3.13,4.13,6.09-.81,1.9-2.31,2.7-4.28,2.7-5.83-.02-11.67-.01-17.52-.01-5.29,0-10.56.04-15.84-.01-3.18-.02-5.23-3.18-3.99-6.08Zm20.67,23.67c-5.51,0-11.03.02-16.55-.01-3.28-.02-5.39-3.13-4.12-6.09.8-1.9,2.3-2.7,4.27-2.7,5.98.02,11.96.01,17.94.01,5.15,0,10.28-.04,15.42.01,3.18.04,5.23,3.18,3.99,6.09-.8,1.89-2.3,2.7-4.27,2.68-5.56-.01-11.12,0-16.67,0Z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default SCOAdministrativeIcon;
